<template>
    <div class="events-overview-card" :class="['events-overview-card', {'all-activities-overview' : $route.name == 'Activities'}]">
        <div
            v-if="activity_events?.length >= 1 && !loader"
            v-for="(item, index) in activity_events"
            :class="`${item.type} event-item`"
            :key="item.id"
        >
            <!-- TODO: add api event type: "logwork" or "upload" -->
            <div
                v-if="item.type === 'upload' && category.includes('upload')"
                class="comment-wrapper"
            >
                <div class="flex-wrap">
                    <UserAvatar :user="getEventUser(item)"></UserAvatar>
                    <span class="font-semibold">
                        {{ getEventUser(item)?.username }}
                    </span>

                    {{ formatDate(item.real_created_at) }}
                    <router-link v-if="$route.name === 'Activities' && isImage(item.txt1)" :to="`/project/${item.project_id}`">Uploaded Image on {{ getBoardTitle(item.project_id) }}</router-link>
                    <router-link v-else-if="$route.name === 'Activities' && isVideo(item.txt1)" :to="`/project/${item.project_id}`">Uploaded Video on {{ getBoardTitle(item.project_id) }}</router-link>
                    <router-link v-else-if="$route.name === 'Activities'" :to="`/project/${item.project_id}`">Uploaded File on {{ getBoardTitle(item.project_id) }} |</router-link>
                    <a v-if="$route.name === 'Activities'" href="#" @click.prevent="getTaskInfo(item)" class="task-item">{{ item.task_title }}</a>
                </div>

                <div class="img-wrap">
                    <div v-if="isImage(item.txt1)" class="img-holder img" @click.prevent="openImageModal(formatURL(item.txt1), item.txt2)">
                        <img :src="formatURL(item.txt1)" alt="">
                        <i class="icon-zoom-in"></i>
                    </div>
                    <div v-else-if="isVideo(item.txt1)" @click="openVideoModal(item.txt1, item.txt2)" class="img-holder video-holder">
                        <i class="icon-one-step-forward play-video-icon"></i>
                    </div>
                    <div v-else>
                        Uploaded file {{item.txt2}}
                        <a :href="formatURL(item.txt1)" target="_blank" download>
                            <i class="icon-download-small"></i>
                        </a>
                        <a href="#" @click.prevent="deleteActivityObj = item, openDeleteActivityModal()" style="margin-left: 5px;">
                            <i class="icon-delete-small"></i>
                        </a>
                    </div>
                    <div v-if="isImage(item.txt1) || isVideo(item.txt1)" class="flex-column">
                        <p>{{item.txt2}}</p>
                        <a v-if="isImage(item.txt1)" class="flex-gap-9" href="#" @click.prevent="openImageModal(formatURL(item.txt1), item.txt2)">
                            <i class="icon-edit-small"></i>
                            <span>Open</span>
                        </a>
                        <a v-if="isVideo(item.txt1)" class="flex-gap-9" href="#" @click.prevent="openVideoModal(item.txt1, item.txt2)">
                            <i class="icon-edit-small"></i>
                            <span>Open</span>
                        </a>
                        <a class="flex-gap-9" :href="formatURL(item.txt1)" target="_blank" download>
                            <i class="icon-download-small"></i>
                            Download
                        </a>
                        <!-- <a class="flex-gap-9" :href="item.body.url" target="_blank" download>
                            <i class="icon-edit-small"></i>
                            Edit
                        </a> -->
                        <a class="flex-gap-9" href="#" @click.prevent="deleteActivityObj = item, openDeleteActivityModal()">
                            <i class="icon-delete-small"></i>
                            Delete
                        </a>
                    </div>
                </div>
            </div>

            <div
                class="comment-wrapper flex-wrap"
                v-if="item.type === 'logwork' && category.includes('logwork')"
            >
                <UserAvatar :user="getEventUser(item)"></UserAvatar>
                <span class="font-semibold">
                    {{ getEventUser(item)?.username }}
                </span>
                <span class="font-semibold">
                    <!-- UTC (s) -- ISO (ms) date -->
                    {{ formatDate(item.real_created_at) }}
                </span>
                <span>
                    Logged
                    <span class="font-semibold">
                        {{ Math.floor(item.uint1 / 60) }}h
                        {{ item.uint1 % 60 }}m
                    </span>
                    for day
                    <span class="font-semibold">
                        {{ getCorrectDate(item.created) }}
                    </span>
                    <span v-if="$route.name === 'Activities'">
                        <span>for </span>
                        <router-link :to="`/project/${item.project_id}`">{{ getBoardTitle(item.project_id) }}</router-link> |
                        <a href="#" @click.prevent="getTaskInfo(item)" class="task-item">{{ item.task_title }}</a>
                    </span>
                </span>
                <div class="comment-nav-btns">
                    <button
                        @click="deleteActivityObj = item, openDeleteActivityModal()"
                        class="comment-btn"
                    >
                        <i class="icon-delete-small"></i>
                    </button>
                </div>
            </div>
            <div
                class="comment-wrapper"
                v-if="item.type === 'comment' && category.includes('comment')"
            >
                <div class="flex-wrap">
                    <UserAvatar :user="getEventUser(item)"></UserAvatar>
                    <span class="comment-user">{{ getEventUser(item)?.username }} commented: </span>
                    <span>{{ formatDate(item.real_created_at) }}</span>
                    <router-link v-if="$route.name === 'Activities'" :to="`/project/${item.project_id}`">on {{ getBoardTitle(item.project_id) }} |</router-link>
                    <a v-if="$route.name === 'Activities'" href="#" @click.prevent="getTaskInfo(item)" class="task-item">{{ item.task_title }}</a>
                    <div class="comment-nav-btns" v-if="editCommentID !== item.id">
                        <button
                            @click="openEditComment(item, index)"
                            class="comment-btn"
                        >
                            <i class="icon-edit-small"></i>
                        </button>
                        <button
                            @click="copyComment(item)"
                            class="comment-btn"
                            :ref="'copy-comment' + item.id"
                            v-if="!showCopied || !copiedCommentID || copiedCommentID !== item.id"
                        >
                            <i class="icon-copy-small"></i>
                        </button>
                        <button
                            @click="deleteActivityObj = item, openDeleteActivityModal()"
                            class="comment-btn"
                        >
                            <i class="icon-delete-small"></i>
                        </button>

                        <span v-if="showCopied && copiedCommentID && copiedCommentID == item.id">Copied</span>
                    </div>
                </div>
                <div
                    class="comment-content"
                    v-html="item.txt1_html"
                    v-if="editCommentID !== item.id"
                ></div>
                
                <!-- <div class="comment-reply flex-gap-9">
                    <img src="../../assets/images/reply.svg" alt="">
                    <span class="ellipse"></span>
                    <span>Reply</span>
                </div> -->

                <div class="edit-comment-parent" v-if="editCommentID === item.id">
                    <TextArea
                        v-model="editCommentText"
                        :placeholder="'Edit comment...'"
                        :overflow="true"
                        :inputClass="'mb-10'"
                        :required="true"
                        :ref="`editCommentTextarea-${index}`"
                        @focus="setTextareaHeight(`editCommentTextarea-${index}`)"
                        @ctrlEnter="editComment(item)"
                    />
                    <div class="hint">Press Control + Enter to Save</div>
                    <VButton
                        :disabled="editCommentText.trim() == ''" @clickHandler="editComment(item)"
                        active
                    >Update</VButton>
                    <VButton
                        :disabled="editCommentText.trim() == ''" @clickHandler="editCommentID = !editCommentID === item.id"
                    >Cancel</VButton>
                </div>
            </div>
            <div
                class="comment-wrapper flex-wrap"
                v-if="item.type === 'edit_task_title' && category.includes('edit_task_title')"
            >
                <UserAvatar :user="getEventUser(item)"></UserAvatar>
                <span class="font-semibold">
                    {{ getEventUser(item)?.username }}
                </span>
                <span class="font-semibold">
                    <!-- UTC (s) -- ISO (ms) date -->
                    {{ formatDate(item.real_created_at) }}
                </span>
                <span>
                    <span style="color: #BB9BFF;">Changed the title </span>from <strong>{{ item.txt2 }}</strong> to <strong>{{ item.txt1 }}</strong>
                    <span v-if="$route.name === 'Activities'">
                        <span>for </span>
                        <router-link :to="`/project/${item.project_id}`">{{ getBoardTitle(item.project_id) }}</router-link> |
                        <a href="#" @click.prevent="getTaskInfo(item)" class="task-item">{{ item.task_title }}</a>
                    </span>
                </span>
            </div>
            <div
                class="comment-wrapper flex-wrap"
                v-if="item.type === 'edit_task_body' && category.includes('edit_task_body')"
            >
                <UserAvatar :user="getEventUser(item)"></UserAvatar>
                <span class="font-semibold">
                    {{ getEventUser(item)?.username }}
                </span>
                <span class="font-semibold">
                    <!-- UTC (s) -- ISO (ms) date -->
                    {{ formatDate(item.real_created_at) }}
                </span>
                <span>
                    <a
                        href="#"
                        style="color: #BB9BFF;"
                        @click.prevent="showEditedBody(item)"
                    >Edited Body</a>
                    <span v-if="$route.name === 'Activities'">
                        <span>for </span>
                        <router-link :to="`/project/${item.project_id}`">{{ getBoardTitle(item.project_id) }}</router-link> |
                        <a href="#" @click.prevent="getTaskInfo(item)" class="task-item">{{ item.task_title }}</a>
                    </span>
                </span>
            </div>
            <div
                class="comment-wrapper flex-wrap"
                v-if="item.type === 'move_task' && category.includes('move_task')"
            >
                <UserAvatar :user="getEventUser(item)"></UserAvatar>
                <span class="font-semibold">
                    {{ getEventUser(item)?.username }}
                </span>
                <span class="font-semibold">
                    <!-- UTC (s) -- ISO (ms) date -->
                    {{ formatDate(item.real_created_at) }}
                </span>
                <span v-if="item.uint2 != item.list_id">
                    <span style="color: #BB9BFF;">Moved task</span> to list <strong>{{ getListName(item.list_id) }}</strong>
                    <span v-if="$route.name === 'Activities'">
                        <span>for </span>
                        <router-link :to="`/project/${item.project_id}`">{{ getBoardTitle(item.project_id) }}</router-link> |
                        <a href="#" @click.prevent="getTaskInfo(item)" class="task-item">{{ item.task_title }}</a>
                    </span>
                </span>
                <span v-else>
                    <span style="color: #BB9BFF;">Moved task</span> on list <strong>{{ getListName(item.list_id) }}</strong> <span>before task </span> <strong >{{ getTaskName(item.uint1) }}</strong>
                    <span v-if="$route.name === 'Activities'">
                        <span>for </span>
                        <router-link :to="`/project/${item.project_id}`">{{ getBoardTitle(item.project_id) }}</router-link> |
                        <a href="#" @click.prevent="getTaskInfo(item)" class="task-item">{{ item.task_title }}</a>
                    </span>
                </span>
            </div>
        </div>
        <div v-if="loader" class="loading-activities">
            Loading Activities <LoaderAnimationVue color="#fff" />
        </div>
        <div v-else-if="activity_events?.length <= 0" class="loading-activities">
            No activities here
        </div>

        <VModal ref="clipboard-modal" size="xl-pd-10" :flexheight="true">
            <ImageEditor @convertToBlob="convertToBlob" :clipboard_img="imgPreviewUrl" :clipboardImageName="imgPreviewName" />
        </VModal>

        <VModal ref="video-preview-modal" class="video-preview-modal" size="xl-pd-10">
            <!-- <input class="clipboard-input" disabled v-model="recording_name" type="text"> -->
            <div class="clipboard-input">{{ recording_name }}</div>
            <div class="video-holder" v-if="videoOptions">
                <VideoPlayer :options="videoOptions" />
            </div>
        </VModal>

        <VModal ref="edit-event-modal" class="edit-event-modal" size="lg">
            <div class="text-holder" v-html="editedBody?.txt1_html"></div>
            <CopyBtn @mouseDownHandler="funcKeyPressed = true" :value="editedBody?.txt1" />
        </VModal>

        <ConfirmDelete ref="confirm-activity-delete" id="confirm-activity-delete" title="Activity" @delete="deleteActivity"/>

        <ConfirmDelete
            ref="delete-recording-modal"
            id="delete-recording-modal"
            class="delete-recording-modal"
            title="video"
            @delete="deleteVideo()"
        />
        <Flash ref="show"/>
    </div>
</template>

<script>
import axios from "axios";
import VModal from "@/components/atoms/VModal.vue";
import Flash from "@/components/Flash.vue";
import ConfirmDelete from "@/components/organism/Confirm.vue";
import TextArea from "@/components/atoms/TextArea.vue";
import VButton from "@/components/atoms/VButton.vue";
import UserAvatar from "@/components/atoms/UserAvatar.vue";
import LoaderAnimationVue from "@/components/atoms/LoaderAnimation.vue";
import ImageEditor from "@/components/molecules/ImageEditor.vue";
import {api} from "@/mixins/axios";
import {baseURL} from "@/mixins/helpers";
import VideoPlayer from "@/components/atoms/VideoPlayer.vue";
import CopyBtn from "@/components/atoms/CopyBtn.vue";

export default {
    name: "EventsCard",
    components: {
        VModal,
        TextArea,
        VButton,
        ConfirmDelete,
        UserAvatar,
        LoaderAnimationVue,
        ImageEditor,
        Flash,
        VideoPlayer,
        CopyBtn,
    },
    props: {
        category: {
            type: Array,
            default: ["logwork", "upload", "comment", "edit_task_title", "edit_task_body", "move_task"],
        },
        task: Object,
        loader: {
            type: Boolean,
            default: false
        },
        openEditTask: Function,
        tags: {},
        events: {},
    },
    data: function () {
        return {
            img_extension: ["png", "jpeg", "jpg", "svg"],
            video_extension: ["mp4", "mov", "wmv", "flv", "webm", "mkv", "avi"],
            imgPreviewUrl: "",
            imgPreviewName: "",
            editCommentID: null,
            editCommentText: '',
            clipboard_img_blob: null,
            uploadedFile: null,
            chunkSize: 2 * 1024 * 1024,
            baseURL: baseURL(),
            deleteActivityObj: null,
            actionTimeout: null,
            showCopied: false,
            copiedCommentID: null,
            recording_name: '',
            editedBody: null,
            videoOptions: null,
            uploadLimit: 300,
        };
    },
    computed: {
        boards() {
            return this.$store.getters.boards
        },
        activity_events() {
            return this.events ? this.events : this.task.events
        },
        boardLists() {
            return this.$store.getters.activeBoardTasks
        }
    },
    methods: {
        formatURL(url) {
            return this.baseURL + url + '?original=true'
        },
        isImage(url) {
            let file_extension = "";
            file_extension = url.split(".")[url.split(".").length - 1].toLowerCase();
            return this.img_extension.includes(file_extension);
        },
        isVideo(url) {
            let file_extension = "";
            file_extension = url.split(".")[url.split(".").length - 1].toLowerCase();
            return this.video_extension.includes(file_extension);
        },
        async openImageModal(url, fileName) {
            let dotIndex = fileName.lastIndexOf('.');

            let imageNameWithoutExtension
            if (dotIndex !== -1) {
                imageNameWithoutExtension = fileName.substring(0, dotIndex);
            } else {
                imageNameWithoutExtension = fileName
            }
            this.imgPreviewName = imageNameWithoutExtension
            
            const response = await fetch(url)
            this.clipboard_img_blob = await response.blob()
            this.uploadedFile = this.clipboard_img_blob
            
            let uri = await this.parseURL(this.clipboard_img_blob)
            this.imgPreviewUrl = uri;

            this.$refs['clipboard-modal'].showModal();
        },
        openVideoModal(url, filename) {
            this.videoOptions = null
            this.$refs['video-preview-modal'].showModal()

            this.$nextTick(() => {
                this.recording_name = filename
                //this.$refs.recordedVideo.src = this.formatURL(url)
                this.videoOptions = {
                    controls: true,
                    playbackRates: [1, 1.5, 2, 3, 4, 5],
                    sources: [
                        {
                            src: this.formatURL(url),
                            type: 'video/mp4'
                        }
                    ]
                }
            })
        },
        deleteVideo() {
            this.recording_name = ''
            this.$refs.recordedVideo.src = ''
            this.$refs['video-preview-modal'].hideModal()
        },
        openEditComment(item, index) {
            this.editCommentID = item.id
            this.editCommentText = item.body?.content || item.txt1;
            this.$nextTick(() => {
                this.$refs[`editCommentTextarea-${index}`][0].$el.querySelector('textarea').focus();
            })
        },
        downloadImage(body) {
            axios.get(body.url)
            .then(res => {
				let blob = new Blob([res.data], {type: 'image/png'});
                const link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.setAttribute("download", body.original_filename);
                document.body.appendChild(link);
                link.click();
                URL.revokeObjectURL(link.href);
            })
        },
        setTextareaHeight(refItem) {
            this.$refs[refItem][0].$el.querySelector('textarea').style.overflow = 'auto'
            this.$refs[refItem][0].$el.querySelector('textarea').style.height = 'auto'
            this.$refs[refItem][0].$el.querySelector('textarea').style.height = `${this.$refs[refItem][0].$el.querySelector('textarea').scrollHeight + 50}px`
        },
        jumpToCaret(textarea) {
            setTimeout(() => {
                textarea.blur();
                textarea.focus();
                this.funcKeyPressed = false
            }, 0);
        },
        async editComment(task) {
            try {
                const data = {
                    id: this.editCommentID,
                    txt1: this.editCommentText
                };

                const response = await api.post(`/activity_edit`, data);

                if (response.status === 200) {
                    this.editCommentText = ''
                    this.editCommentID = ''
                    
                    this.$store.dispatch('updateTaskEvent', response.data.data)
                }
            } catch (e) {
                console.error(e);
            }
        },
        openDeleteActivityModal() {
            this.$refs['confirm-activity-delete'].$refs['confirm-activity-delete'].showModal()
        },
        async deleteActivity() {
            try {
                const data = {
                    id: this.deleteActivityObj.id
                };

                const response = await api.post(`/activity_delete`, data);

				console.log(response.status === 200 && this.$route.name == 'Activities')
                if (response.status === 200 && this.$route.name == 'Activities') {
                    this.$emit('getEventsTask')
                    this.deleteActivityObj = null
                } else if(response.status === 200 && this.$route.name != 'Activities') {
                    this.$store.dispatch('deleteTaskEvent', this.deleteActivityObj)
                    this.deleteActivityObj = null
                    this.$forceUpdate()
				}
            } catch (e) {
                console.error(e);
            }
        },
        getCorrectDate(timestamp) {
            const date = new Date(timestamp * 1000);

            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');

            const formattedDate = `${month}/${day}/${year}`;

            return formattedDate;
        },
        formatDate(timestamp) {
            let date = new Date(timestamp * 1000)

			if(this.isLessThan2DaysAgo(date)) {
				return this.time_ago(date)
			} else {
				return `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()} ${date.getHours()}:${('0' + date.getMinutes()).slice(-2)}`;
			}
        },
		time_ago(time) {
			switch (typeof time) {
				case 'number':
					break;
				case 'string':
					time = +new Date(time);
					break;
				case 'object':
					if (time.constructor === Date) time = time.getTime();
					break;
				default:
					time = +new Date();
			}
			const time_formats = [
				[60, 'seconds', 1], // 60
				[120, '1 minute ago', '1 minute from now'], // 60*2
				[3600, 'minutes', 60], // 60*60, 60
				[7200, '1 hour ago', '1 hour from now'], // 60*60*2
				[86400, 'hours', 3600], // 60*60*24, 60*60
				[172800, 'Yesterday', 'Tomorrow'], // 60*60*24*2
				[604800, 'days', 86400], // 60*60*24*7, 60*60*24
				[1209600, 'Last week', 'Next week'], // 60*60*24*7*4*2
				[2419200, 'weeks', 604800], // 60*60*24*7*4, 60*60*24*7
				[4838400, 'Last month', 'Next month'], // 60*60*24*7*4*2
				[29030400, 'months', 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
				[58060800, 'Last year', 'Next year'], // 60*60*24*7*4*12*2
				[2903040000, 'years', 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
				[5806080000, 'Last century', 'Next century'], // 60*60*24*7*4*12*100*2
				[58060800000, 'centuries', 2903040000] // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
			];
			let seconds = (+new Date() - time) / 1000,
			token = 'ago',
			list_choice = 1;

			if (seconds == 0) return 'Just now'
			if (seconds < 0) {
				seconds = Math.abs(seconds);
				token = 'from now';
				list_choice = 2;
			}
			let i = 0,
			format;
			while (format = time_formats[i++])
			if (seconds < format[0]) {
				if (typeof format[2] == 'string')
				return format[list_choice];
				else
				return Math.floor(seconds / format[2]) + ' ' + format[1] + ' ' + token;
			}
			return time;
		},
		isLessThan2DaysAgo(date) {
			const days = 1000 * 60 * 60 * 48;
			const daysAgo = Date.now() - days;
			return date > daysAgo;
		},
        getBoardTitle(id) {
            if (!this.boards) return
            
            const board = this.boards.filter(board => board.id == id)
            return board && board[0] ? board[0].title : 'Unknown Project'
        },
        getListName(list_id) {
            if (!this.boardLists) return

            const list = this.boardLists.filter(list => list.id == list_id)
            return list.length > 0 && list[0].title ? list[0].title : 'Unknown List'
        },
        getTaskName(prev_task_id) {
            if (!this.boardLists) return
            
            const task = [...this.boardLists.map(list => list.tasks).flat()].find(task => task.id == prev_task_id)
            return task?.title || 'Unknown task'
        },
        convertToBlob(canvas, file_name) {
            canvas.toBlob(async (blob) => {
                let uri = await this.parseURL(blob)
                
                this.imgPreviewName = file_name
                this.imgPreviewUrl = uri
                this.clipboard_img_blob = await this.blobToFile(blob);
                
                this.uploadFromClipboard()
            }, 'image/png')
        },
        async parseURL (data) {
			let reader = new FileReader()
			reader.readAsDataURL(data)
			return new Promise((res, rej) => {
				reader.onload = e => {
					res(e.target.result)
				}
			})
		},
        async blobToFile(blob) {
            return new File([blob], `${this.imgPreviewName}.png`, { type: blob.type });
        },
        async uploadFromClipboard() {
            if (!this.clipboard_img_blob) return

            if (this.clipboard_img_blob.size > this.uploadLimit * 1024 * 1024) {
                this.$refs.show.showFlashError(`Files bigger than ${this.uploadLimit}MB are not allowed.`);
                return
            }
            const file = this.clipboard_img_blob
            const totalChunks = Math.ceil(file.size / this.chunkSize);
            let start = 0;
            let fileSent = false
            const uniqueUUID = Date.now()
            this.$store.dispatch('setUploadingState', {total: totalChunks, current: 0, file: file})
            
            this.$refs.show.showFlashWarning('Uploading...')

            for (let chunkNumber = 1; chunkNumber <= totalChunks; chunkNumber++) {
                this.$store.dispatch('setUploadingState', {total: totalChunks, current: chunkNumber, file: file})
                const end = Math.min(start + this.chunkSize, file.size);
                const chunk = file.slice(start, end);
                const newFile = new File([chunk], this.clipboard_img_blob.name, { type: chunk.type })
                const formData = new FormData();
                formData.append('file', newFile);
                formData.append('dztotalfilesize', file.size);
                formData.append('dzchunkindex', chunkNumber - 1);
                formData.append('dztotalchunkcount', totalChunks);
                formData.append('dzuuid', uniqueUUID);
                
                try {
                    const response = await api.post(`/task_upload/${this.task.id}`, formData, {
                        headers: { "Content-Type": "multipart/form-data" },
                    });

                    if (response.data.msg === 'Chunk received') {
                        fileSent = true
                    }
                    start = end;
                } catch (error) {
                    console.log(error);
                    this.$refs.show.showFlashError(error?.response?.data?.msg || error?.message || 'Something went wrong')
                    if(error.response.status === 402) {
                        this.$store.dispatch('updatePlanLimit', 'uploading files');
                    }
                }
            }
            this.$emit('searchActivity');

            if (fileSent) {
                this.$refs.show?.showFlashSuccess('Uploaded');
                //TODO update task state
                this?.$refs['clipboard-modal']?.hideModal()
                this.clipboardImageName = 'file'
                this.uploadedFile = null
                fileSent = false

                setTimeout(() => {
                    this.$store.dispatch('setUploadingState', null)
                }, 1000);
                this.$forceUpdate()
            }
        },
        getEventUser(event) {
            const allUsers = this.boards && this.boards.flatMap(board => board.members)
            if (!allUsers) return
            const uniqueUsers = [];
            const seenUsers = new Set();
            allUsers.forEach(user => {
                if (!seenUsers.has(user)) {
                    uniqueUsers.push(user);
                    seenUsers.add(user);
                }
            });

            return allUsers.find(t => t.id == event.user_id) || {username: 'Unknown'}
        },
        async getTaskInfo(item) {
            try {
                const resp = await api.post('/task_search', {id: item.task_id})
                if (resp.data.msg == 'ok') {
                    this.openEditTask(resp.data.data[0])
                }
            } catch(e) {
                console.log(e);
            }
        },
        async copyComment(comment) {
            try {
                await navigator.clipboard.writeText(comment.txt1);
                this.copiedCommentID = comment.id
                this.showCopied = true;

                if (this.actionTimeout) {
                    clearTimeout(this.actionTimeout);
                }

                this.actionTimeout = setTimeout(() => this.showCopied = false, 1500);
            } catch (err) {
                console.error('Failed to copy: ', err);
                this.$refs.show.showFlashError(`Couldn't copy comment`);
            }
        },
        showEditedBody(event) {
            this.editedBody = event;
            this.$refs['edit-event-modal'].showModal()
        }
    },
};
</script>

<style lang="scss">
.preview-modal-img {
    top: 50%;
    left: 50%;
    height: auto !important;
    width: auto !important;
}

.all-activities-overview {
   color: #fff !important;
}

.events-overview-card {
    height: 100%;
    width: 100%;
    overflow-y: auto;
    margin-bottom: 30px;
    color: var(--secondary-text) !important;

    &:last-child {
        margin-bottom: 0;
    }

    .event-item {
        margin-bottom: 10px;
    }

    .img-holder {
        position: relative;
        border-radius: calc(0.25rem - 1px);
        overflow: hidden;
        font-size: 0;
        margin-top: 5px;
        margin-left: 44px;
        width: 100%;
        max-width: 300px;
        height: 260px;

        &:after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 1;
            background-color: rgba(0, 0, 0, .4);
            opacity: 0;
            visibility: hidden;
            transition: opacity .3s, visibility .3s;
            pointer-events: none;
        }

        &.img:hover {
            cursor: pointer;

            &:after,
            i {
                opacity: 1;
                visibility: visible;
            }
        }

        &.video-holder {
            height: 120px;
            max-width: 180px;
            cursor: pointer;
            outline: 1px solid;

            p {
                margin-bottom: 0;
            }
        }

        img, video {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        i {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 50px;
            z-index: 2;
            opacity: 0;
            visibility: hidden;
            transition: opacity .3s, visibility .3s;
            color: #fff;
            pointer-events: none;
        }

        .play-video-icon {
            visibility: visible;
            opacity: 1;
            font-size: 25px;
        }
    }

    .loading-activities {
        display: flex;
        align-items: center;
        gap: 10px;
    }
}
.img-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
    .flex-column {
        display: flex;
        flex-direction: column;
    }
}

.comment-wrapper {
    padding: 0 0 8px;

    .comment-reply {
        margin-left: 44px;
        font-size: 14px;
        margin-top: 4px;
    }

    .ellipse {
        width: 2px;
        height: 2px;
        flex-shrink: 0;
        border-radius: 50%;
        background-color: #fff;
    }
}

.flex-wrap {
    display: flex;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
}

.edit-comment-parent {
    margin-top: 5px;
    .btn.light-blue {
        width: 80px;
        margin-right: 5px;
    }
}
.comment-nav-btns {
    display: flex;
    align-items: center;
    gap: 5px;

    .comment-btn {
        border: none;
        cursor: pointer;
        padding: 0;

        i:before {
            font-size: 16px;
        }
    }
}

.comment-user {
    color: #D4D4D4;
    margin-right: 10px;
}

.comment-username {
    color: $blue-text;
}

.comment-content {
    background: var(--secondary-bg);
    color: var(--primary-text);
    margin-left: 44px;
    border-radius: 10px;
    padding: 11px 11px 1px;
    word-break: break-word;

    a {
        color: var(--accent) !important;
    }
}
.task-item {
    color: var(--accent);
}

.video-preview-modal {
    .clipboard-input {
        border-radius: 6px;
        border: 1px solid var(--outline);
        background: var(--primary-bg);
        color: var(--primary-text);
        flex-shrink: 0;
        margin-right: 10px;
        margin-bottom: 10px;
        padding: 5px 10px;
        display: inline-block;
        &:focus-visible {
            outline: none;
        }
    }

    .video-holder {
        position: relative;
        padding-bottom: 45%;
    }
}

.edit-event-modal {
    .text-holder {
        background: var(--secondary-bg);
        color: var(--primary-text);
        border-radius: 10px;
        padding: 15px;
        margin-bottom: 10px;
    }

    ul {
        list-style: none;
        padding-left: 0;
    }
}
</style>
